import React, { useEffect, useState } from "react";
import closeicon from "../../assets/popups/close.png";
import Select from "react-select";
import { Checkbox, FormControlLabel } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faL,
  faPenToSquare,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import api from "../../api/api";
import { duration } from "moment/moment";
import { useParams } from "react-router-dom";
import ToastMessage from "../../utils/mui/righttoptoast";
import { useDispatch, useSelector } from "react-redux";
import { setFormData } from "../../reduxtoolkit/orders/prescription";
const NewRxPopup = ({ fetchsuggestions,dt, isOpen, onClose, userdata }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const dispatch = useDispatch();
  const [activeButton, setActiveButton] = useState(3);

  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");
  const [loading, setLoading] = useState(false);
  const [diagnosisText, setDiagnosisText] = useState("");
  const [diagnosisSuggestions, setDiagnosisSuggestions] = useState([]);
  const [diagnosiscode, setDiagnosisCode] = useState("");
  const [isDiagnosisSelected, setIsDiagnosisSelected] = useState(false);
  const [pharmacyText, setPharmacyText] = useState("");
  const [icd, setIcd] = useState("");
  const [ordertypeid, setOrderTypeId] = useState("");
  const [pharmacySuggestions, setPharmacySuggestions] = useState([]);
  const [isPharmacySelected, setIspharmacySelected] = useState(false);
  const [MedicationText, setMedicationText] = useState("");
  const [medicationid, setMedicationId] = useState("");
  const [topmedication, setTopMedication] = useState([]);
  const [MedicationSuggestions, setMedicationSuggestions] = useState([]);
  const [isMedicationSelected, setIsMedicationSelected] = useState(false);
  const [isPharmacyLocked, setIsPharmacyLocked] = useState(false);

  const practiseid = window.getPracticeId();
  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
  const userConfig = useSelector((state) => state.userconfig);
  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );
  const [formdata, setFormdata] = useState({
    dosagequantity: "",
    dqunit: "",
    frequency: "",
    duration: "",
    note: "",
    quantity: "",
  });
  const handleButtonClick = (index) => setActiveButton(index);
  const handleClear = () => {
    setFormdata({
      dosagequantity: "",
      dqunit: "",
      frequency: "",
      duration: "",
      note: "",
      quantity: "",
    });
    setDiagnosisText("");
    setDiagnosisSuggestions([]);
    setDiagnosisCode("");
    setIsDiagnosisSelected(false); // This should be a boolean, not an empty string
    setPharmacyText("");
    setPharmacySuggestions([]);
    setIspharmacySelected(false); // This should be a boolean, not an empty string
    setMedicationText("");
    setMedicationId("");
    setTopMedication([]);
    setMedicationSuggestions([]);
    setOrderTypeId("");
    setIsMedicationSelected(false); // This should be a boolean, not an empty string
  };

  // Fetch Diagnosis Suggestions API
  const fetchSuggestions = async () => {
    if (diagnosisText.trim().length > 1) {
      // Trigger API only after 3 characters
      try {
        const response = await api.post(
          `/v1/${practiseid}/orders/patient/${userdata.patientid}/get-search-diagnosis`,
          {
            searchVal: diagnosisText,
          }
        );
        if (response.status === 200) {
          setDiagnosisSuggestions(response.data.slice(0, 5) || []);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      } finally {
      }
    }
  };


const fetchpharmacydata = async () => {
  try {
    const response = await api.get(
      `/v1/${practiseid}/rx/patient/${userdata.patientid}/department/${userConfig.config.departmentid}/pharmacy`
    );

    if (response.status === 200) {
      const name = response.data?.clinicalprovidername || "";
      setPharmacyText(name);
      setIspharmacySelected(true);   // prevent suggestions
      setIsPharmacyLocked(true);     // 🔒 disable input
    }
  } catch (error) {
    console.log(error);
  }
};


  const handleToastClose = () => {
    setOpenToast(false);
  };
  useEffect(() => {
    if (diagnosisText.trim() === "" || isDiagnosisSelected) {
      setDiagnosisSuggestions([]);
      setIsDiagnosisSelected(false);

      return;
    }

    const delayDebounceFn = setTimeout(() => {
      fetchSuggestions();
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [diagnosisText]);
  const fetchMedicationSuggestions = async () => {
    if (MedicationText.trim().length > 1) {
      // Trigger API only after 3 characters
      try {
        const response = await api.post(
          `/v1/${practiseid}/rx/medicationlookup/5`,
          {
            lookup: MedicationText,
          }
        );
        if (response.status === 200) {
          setMedicationSuggestions(response.data || []);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      } finally {
      }
    }
  };

  useEffect(() => {
    if (MedicationText.trim() === "" || isMedicationSelected) {
      setMedicationSuggestions([]);
      setIsMedicationSelected(false);

      return;
    }

    const delayDebounceFn = setTimeout(() => {
      fetchMedicationSuggestions();
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [MedicationText]);

  const fetchPharmacySuggestions = async () => {
    if (pharmacyText.trim().length > 1) {
      // Trigger API only after 3 characters
      try {
        const response = await api.post(
          `/v1/${practiseid}/rx/patient/${userdata.patientid}/department/${userdata.departmentid}/pharmalook`,
          {
            facility_name: pharmacyText,
          }
        );
        if (response.status === 200) {
          setPharmacySuggestions(response.data.slice(0, 5) || []);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
      } finally {
      }
    }
  };

 useEffect(() => {
  if (pharmacyText.trim() === "" || isPharmacySelected || isPharmacyLocked) {
    setPharmacySuggestions([]);
    return;
  }

  const delayDebounceFn = setTimeout(() => {
    fetchPharmacySuggestions();
  }, 500);

  return () => clearTimeout(delayDebounceFn);
}, [pharmacyText, isPharmacySelected, isPharmacyLocked]);

  const fetchTopMedication = async () => {
    try {
      const response = await api.get(
        `/v1/${practiseid}/rx/${userdata.patientid}/topmedication/4/0`
      );
      if (response.status === 200) {
        setTopMedication(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (isOpen) {
      fetchpharmacydata();
      fetchTopMedication();
    }
  }, [isOpen]);

  const submitMedication = async () => {
    try {
      setLoading(true);
      dispatch(setFormData(formdata));
      const checkmedication = await api.post(
        `/v1/${practiseid}/orders/patient/${userdata.patientid}/prescription/check`,
        {
          medicationname: MedicationText,
        }
      );
      if (checkmedication.status == 200) {
      } else {
        let payload = {
          pat_name: `${userdata.firstname || ""} ${
            userdata.lastname || ""
          }`.trim(),
          encounterid:
            typeof userdata.encounterid === "number"
              ? userdata.encounterid
              : undefined,
          ordertypeid: ordertypeid,
          medication: MedicationText,
          provider_name: userConfig?.username,
          medicationid: medicationid,
          pharmacyname: pharmacyText,
          diagnosissnomedcode: diagnosiscode,
          duration: formdata.duration,
          frequency: formdata.frequency,
          dosagequantityunit: formdata.dqunit,
          dosagequantity: formdata.dosagequantity,
          numrefillsallowed: activeButton,
          totalquantity: formdata.quantity,
          confirm_status: "C",
          orderdate:
            dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
              ? dt.split(" ")[0]
              : new Date().toISOString().split("T")[0],
          providernote: formdata.note,
          lov: lovValue,
          tov: tovValue,
          diagnosis: icd,
        };
        if (payload.encounterid === undefined) {
          delete payload.encounterid;
        }
        const response = await api.post(
          `/v1/${practiseid}/rx/patient/${userdata.patientid}/create`,
          payload
        );

        if (response.status == 200) {
          fetchsuggestions();
          setToastMessage("Notes added successfully!");
          setToastSeverity("success");
          setOpenToast(true);
          setTimeout(() => {
            setOpenToast(false);
            handleClear();
            onClose(); // Auto-close popup after 2 seconds
          }, 2000);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 overflow-auto   custom-scrollbar flex items-center justify-center z-50">
          {/* Popup Box */}
          <div
            className="relative flex flex-col gap-4 w-[386px] bg-white px-4 pb-6 mb-1 rounded-lg shadow-lg text-left overflow-y-auto"
            style={{
              height: "80vh", // 70% viewport height
              maxHeight: "90vh", // prevent overflow beyond screen
            }}
          >
            <div>
              <div className="w-full flex items-center justify-between mt-2">
                {/* Close Button */}
                <span className="ml-2 font-semibold text-[#1D2951] text-base text-center tracking-[0] leading-[normal] whitespace-nowrap">
                  New Rx
                </span>
                <button
                  className="text-gray-500 hover:text-gray-700 text-[30px]"
                  onClick={() => {
                    handleClear();
                    onClose();
                  }}
                >
                  &times;
                </button>
              </div>
              <div className="h-px bg-[#D0D5DD]"></div>
            </div>

            <div className="relative w-full max-w-md">
              {/* Left-aligned search icon */}
              <FontAwesomeIcon
                icon={faSearch}
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
              />

              {/* Search input field with reduced height */}
              <input
                type="text"
                className="rounded w-[100%] border border-[#D5D5D5] bg-[#F5F6FA]  pl-10 pr-16 py-1 text-base outline-none"
                placeholder="Enter medication name"
                value={MedicationText}
                onChange={(e) => setMedicationText(e.target.value)}
              />
            </div>
            {MedicationText &&
              !isMedicationSelected &&
              MedicationSuggestions.length > 0 && (
                <ul className="mt-2 w-full border rounded-xl">
                  {MedicationSuggestions.map((suggestion, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        setMedicationText(suggestion.medication); // Set the selected diagnosis
                        setMedicationSuggestions([]);
                        setOrderTypeId(suggestion.clinicalordertypeid);
                        setMedicationId(suggestion.medicationid); // Clear the suggestions after selection
                        setIsMedicationSelected(true);
                      }}
                      className="p-2 hover:bg-gray-200 text-xs cursor-pointer"
                    >
                      {suggestion.medication}
                    </li>
                  ))}
                </ul>
              )}
            <div className="w-full flex flex-wrap">
              {topmedication.length > 0 &&
                topmedication.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      setIsMedicationSelected(true);
                      setMedicationId(item.medicationid);
                      setOrderTypeId(item.clinicalordertypeid);
                      setMedicationText(item.medication);
                    }}
                    className={`cursor-pointer text-[10px] font-poppins tracking-tight font-thin text-center rounded-full shadow-md flex items-center justify-center transition-colors duration-300 ease-in-out
      ${
        MedicationText == item.medication
          ? "bg-[#e17954] text-white"
          : "bg-white text-[#1D2951]"
      }
      px-2 h-[25px]`} // Reduced size
                    style={{ margin: "2px" }}
                  >
                    {item.medication}
                  </div>
                ))}
            </div>

            <div className="flex flex-col gap-2">
              <label className="text-[#232323]">Diagnosis </label>
              <div className="w-full flex items-center">
                <input
                  type="text"
                  className="w-full border rounded-xl p-3 h-10"
                  placeholder="Diagnosis Search"
                  value={diagnosisText}
                  onChange={(e) => setDiagnosisText(e.target.value)}
                />
                {/* <FontAwesomeIcon icon={faPenToSquare} className="ml-2 text-[#E17954] text-lg" /> */}
              </div>

              {/* Display diagnosis suggestions as a list */}
              {diagnosisText &&
                !isDiagnosisSelected &&
                diagnosisSuggestions.length > 0 && (
                  <ul className="mt-2 w-full border rounded-xl">
                    {diagnosisSuggestions.map((suggestion, index) => (
                      <li
                        key={index}
                        onClick={() => {
                          setDiagnosisText(suggestion.condition_name);
                          setDiagnosisCode(suggestion.snomed_code); // Set the selected diagnosis
                          setIcd(suggestion.icd10);
                          setDiagnosisSuggestions([]); // Clear the suggestions after selection
                          setIsDiagnosisSelected(true);
                        }}
                        className="p-2 hover:bg-gray-200 text-xs cursor-pointer"
                      >
                        {suggestion.condition_name}
                      </li>
                    ))}
                  </ul>
                )}
            </div>

            {/* Rest of the Form Fields */}
            <div className="w-full flex gap-4">
              <div className="flex flex-col gap-2">
                <label className="text-[#232323]">Dosage Quantity</label>
                <input
                  type="text"
                  className="w-full border rounded-xl p-3 h-10"
                  placeholder="Dosage Quantity"
                  value={formdata.dosagequantity}
                  onChange={(e) =>
                    setFormdata({ ...formdata, dosagequantity: e.target.value })
                  }
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="text-[#232323]">DQ Unit</label>
                <input
                  type="text"
                  className="w-full border rounded-xl p-3 h-10"
                  placeholder="DQ unit"
                  value={formdata.dqunit}
                  onChange={(e) =>
                    setFormdata({ ...formdata, dqunit: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="w-full flex gap-4">
              <div className="flex flex-col gap-2">
                <label className="text-[#232323]">Frequency</label>
                <input
                  type="text"
                  className="w-full border rounded-xl p-3 h-10"
                  placeholder="Frequency"
                  value={formdata.frequency}
                  onChange={(e) =>
                    setFormdata({ ...formdata, frequency: e.target.value })
                  }
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="text-[#232323]">Duration (days)</label>
                <input
                  type="text"
                  className="w-full border rounded-xl p-3 h-10"
                  placeholder="Duration"
                  value={formdata.duration}
                  onChange={(e) =>
                    setFormdata({ ...formdata, duration: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <label className="text-[#232323]">Pharmacy</label>
              <div className="w-full flex items-center">
                {/* <input
                  type="text"
                  className="w-full border rounded-xl p-3 h-10"
                  placeholder="Enter Pharmacy..."
                  value={pharmacyText}
                  onChange={(e) => setPharmacyText(e.target.value)}
                /> */}
                <input
  type="text"
  disabled={isPharmacyLocked}
  className={`w-full border rounded-xl p-3 h-10 ${
    isPharmacyLocked ? "bg-gray-100 cursor-not-allowed" : ""
  }`}
  placeholder="Enter Pharmacy..."
  value={pharmacyText}
  onChange={(e) => {
    setPharmacyText(e.target.value);
    setIspharmacySelected(false);
  }}
/>

              <FontAwesomeIcon
  icon={faPenToSquare}
  className="ml-2 text-[#E17954] text-lg cursor-pointer"
  onClick={() => {
    setIsPharmacyLocked(false);     // 🔓 enable input
    setIspharmacySelected(false);   // allow suggestions
  }}
/>

              </div>
              {pharmacyText &&
                !isPharmacySelected &&
                pharmacySuggestions.length > 0 && (
                  <ul className="mt-2 w-full border rounded-xl">
                    {pharmacySuggestions.map((suggestion, index) => (
                      <li
                        key={index}
                        onClick={() => {
                          setPharmacyText(suggestion.name); // Set the selected diagnosis
                          setPharmacySuggestions([]); // Clear the suggestions after selection
                          setIspharmacySelected(true);
                        }}
                        className="p-2 hover:bg-gray-200  text-xs cursor-pointer"
                      >
                        {suggestion.name}
                      </li>
                    ))}
                  </ul>
                )}
            </div>

            <div className="flex flex-col space-y-1 w-full">
              <label className="text-[#232323]">Patient Note</label>
              <textarea
                className="w-full h-22 p-3 border border-gray-300 rounded-md resize-none"
                placeholder="Type your note here..."
                value={formdata.note}
                onChange={(e) =>
                  setFormdata({ ...formdata, note: e.target.value })
                }
              ></textarea>
            </div>

            <div className="w-full flex gap-4">
              <div className="flex flex-col gap-2">
                <label className="text-[#232323]">Refills Allowed</label>
                <div className="flex items-center gap-3 px-0 py-1">
                  {[0, 1, 2, 3].map((number) => (
                    <button
                      key={number}
                      onClick={() => handleButtonClick(number)}
                      className={`w-9 h-[32px] flex items-center justify-center rounded-lg shadow-[0px_0px_4px_2px_#0000001a] ${
                        activeButton === number
                          ? "bg-[#e17954] text-white"
                          : "bg-white text-[#1d2951]"
                      }`}
                    >
                      <div className="font-bold text-[10px] text-center">
                        {number}
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              <div className="flex flex-col gap-2">
                <label className="text-[#232323]">Total Quantity</label>
                <input
                  type="text"
                  className="w-full border rounded-xl p-3 h-10"
                  placeholder="Total Quantity"
                  value={formdata.quantity}
                  onChange={(e) =>
                    setFormdata({ ...formdata, quantity: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="w-full flex justify-center mt-2">
              <button
                onClick={() => submitMedication()}
                disabled={loading} // Disable button when loading
                className={`rounded py-2 w-full font-Font1 px-4 text-sm transition duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] ${
                  loading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[black] text-[#FFFFFF]"
                }`}
              >
                {loading ? "submitting..." : "Add Rx Medication"}
              </button>
            </div>
          </div>
        </div>
      )}
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={handleToastClose}
      />
    </>
  );
};

export default NewRxPopup;
